var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconLogoGoogle = function SvgIconLogoGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 11.958c0-.73-.06-1.46-.184-2.179H12.713v4.126h5.786a4.96 4.96 0 0 1-2.14 3.256v2.678h3.454C21.835 17.975 23 15.218 23 11.958Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.713 22.426c2.89 0 5.325-.949 7.1-2.586l-3.454-2.678c-.96.652-2.199 1.024-3.647 1.024-2.794 0-5.166-1.884-6.014-4.422H3.141v2.76a10.713 10.713 0 0 0 9.572 5.902Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.698 13.764a6.419 6.419 0 0 1 0-4.1v-2.76H3.141a10.713 10.713 0 0 0 0 9.62l3.557-2.76Z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.713 5.241a5.816 5.816 0 0 1 4.11 1.607l3.057-3.057A10.294 10.294 0 0 0 12.713 1 10.713 10.713 0 0 0 3.14 6.903l3.557 2.76c.848-2.538 3.22-4.422 6.014-4.422Z",
    fill: "#EA4335"
  })));
};
export default SvgIconLogoGoogle;